/* global Option, gon */

import ApplicationController from '../application_controller'

class UnitIdsInputController extends ApplicationController {
  connect () {
    (function () {
      const unitsSelect = $(this.element)
      const positionSelect = $('#employee_position_id')[0]

      if (unitsSelect.length === 0 || !positionSelect) return

      const filterPositions = (unitIds) => {
        const ids = unitIds.filter(item => item !== undefined)
        return gon.userPositions.filter(position => {
          if (ids.length === 0) return true

          return ids.includes(position.unit_id.toString())
        }
        ).map(position => [position.name, position.id])
      }

      const updateSelect = (positionsCollection) => {
        const selectedValue = positionSelect.options[positionSelect.selectedIndex].value
        while (positionSelect.options.length > 0) {
          positionSelect.remove(0)
        }
        const newOption = new Option('', '')
        positionSelect.add(newOption, undefined)

        positionsCollection.forEach((positionData) => {
          const newOption = new Option(positionData[0], positionData[1])
          positionSelect.add(newOption, undefined)
        })

        positionSelect.value = selectedValue
      }

      const populatePositionSelect = (unitIds = []) => {
        if (gon.userPositions.length === 1) unitIds.push(gon.userPositions[0]?.value)
        const positionsCollection = filterPositions(unitIds)
        updateSelect(positionsCollection)
      }

      unitsSelect.select2()
      populatePositionSelect()

      unitsSelect.on('change', function (event) {
        const unitIds = [...event.val]
        populatePositionSelect(unitIds)
      })
    }).call(this)
  }
}

export default UnitIdsInputController
